import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "history-table" }
const _hoisted_2 = { class: "table-bg" }
const _hoisted_3 = {
  key: 0,
  class: "items-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_responsive = _resolveDirective("responsive")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-item head" }, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "bg-item",
          key: `bg-${i}`
        }))
      }), 128))
    ]),
    _createElementVNode("table", null, [
      _createElementVNode("colgroup", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, i) => {
          return (_openBlock(), _createElementBlock("col", {
            key: `c-${i}`,
            style: _normalizeStyle({ width: `${column}` })
          }, null, 4))
        }), 128))
      ]),
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.header, (item, i) => {
            return (_openBlock(), _createElementBlock("th", {
              key: `h-${i}`,
              class: _normalizeClass([_ctx.columns[i]])
            }, _toDisplayString(item), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    (!_ctx.count)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t('HistoryTable.placeholder')), 1))
      : _createCommentVNode("", true)
  ])), [
    [_directive_responsive, {
			xs: (el) => el.width < 600,
			sm: (el) => el.width < 700,
			md: (el) => el.width < 800
		}]
  ])
}